import { IconName } from '@fortawesome/fontawesome-svg-core';

import { IItemSocialMedia } from '@core/models/interfaces/social-media.interface';
import { environment } from '@env/environment';

export class SocialMediaItem {
  title!: string;
  href!: string;
  icone!: IconName;
  image!: string;
  class?: string;

  constructor(value: IItemSocialMedia) {
    Object.assign(this, value);
    this.image = this.getImagePath(value.image);
  }

  getImagePath(imageName: string): string {
    return `${environment.endpoint.assets}/${imageName}`;
  }
}
